module.exports = __webpack_public_path__ + "static/media/iphone.4f377a09.png";